import React, { useState, useEffect, useRef } from "react";
import "./ListRoles.scss";
import "../DashBoard/sliding.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import { userReducer } from "../../Redux/store";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import td from '@mui/material/td';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
// import { TableVirtuoso, TableComponents } from 'react-virtuoso';

import SearchBarComponent from "../../components/searchBar/searchBarComponent";
// import { ReactComponent as UserSVG} from s'../../images/user-filled-svgrepo-com.svg';
import { ReactComponent as UserSVG } from '../../images/new_ui/role.svg';
import { ReactComponent as UsersSVG } from "../../images/new_ui/users.svg";
import { ReactComponent as DeleteSVG } from "../../images/new_ui/delete-purple.svg";
import { ReactComponent as EditSVG } from "../../images/new_ui/edit-purple.svg";
import { ReactComponent as AddSVG } from "../../images/new_ui/addArrow.svg";
import { useNavigate } from "react-router-dom";

import {
  SuccessAlert,
  FailureAlert,
  InformationAlert,
  SuccessUpdate,
  FailureUpdate,
  SuccessDelete,
} from "../../components/Alert_msg/alert_msg";
// import ListPermissions from "../ListPermissions/ListPermissions";

function ListRoles() {
  const navigate = useNavigate();
  // Dispatch function
  const dispatch = useDispatch();

  //API related selectors
  const token = useSelector((state) => state.AccessTocken.accessTocken);

  //Permission for Roles
  // const Add_Permission = useSelector(
  //   (state) => state.AccessTocken.Add_Permission
  // );
  // const Edit_Permission = useSelector(
  //   (state) => state.AccessTocken.Edit_Permission
  // );
  // const Delete_Permission = useSelector(
  //   (state) => state.AccessTocken.Delete_Permission
  // );
  // const View_Permission = useSelector(
  //   (state) => state.AccessTocken.View_Permission
  // );

  // const user_edit = useSelector((state) => state.user.user_edit);
  const [userData, setUserData] = useState([]);


  const [userValidated, setUserValidated] = useState(false);
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteOpen, setDeleteOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [selectedRoleName, setSelectedRoleName] = useState('');
  const openPopup = () => {
    setIsOpen(true);
  };

  const closePopup = () => {
    setIsOpen(false);
    getSelectedUser(null);
  };

  const closeUpdateUserPopup = () => {
    setIsOpen(false);
    getSelectedUser(null);
    setUserData([])
    // getUsersList();
  }

  const [isPermissionOpen, setIsPermissionOpen] = useState(false);
  const [selectedUser, getSelectedUser] = useState(null);

  const openPermissionPopup = () => {
    setIsPermissionOpen(true);
  };

  const closePermissionPopup = () => {
    setIsPermissionOpen(false);
  };

  const openDeleteModal = (roleId, roleName) => {
    setSelectedRoleId(roleId);
    setSelectedRoleName(roleName);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setSelectedRoleId(null);
    setSelectedRoleName('');
    setShowDeleteModal(false);
  };

  //Header for API's
  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const listLimit = useSelector((state) => state.AccessTocken.recordsPerPage);

  // division response for Division Dropdown


  // async function getUsersList() {
  //     dispatch(sidebarReducer.apiLoad(true));
  //     // setApiLaod(true);
  //     await axios

  //         .get("rolepermission/allUsersForSpecificCompany/" + JSON.parse(sessionStorage.getItem("userdata")).te_companyid)
  //         // .get("userProfile/getAllUsers")
  //         .then((response) => {
  //             if (response.status === 200) {
  //                 dispatch(sidebarReducer.apiLoad(false));
  //                 //setApiLaod(false);
  //                 console.log("getAllUsers2", response.data.length)
  //                 setUserData(response.data.result[0].response);
  //             } else if (response.status !== 200) {
  //                 dispatch(sidebarReducer.stringUpdate("AppDown"));
  //             }
  //         })
  //         .catch((err) => {
  //             dispatch(sidebarReducer.stringUpdate("AppDown"));
  //         });
  // }
  var addnameColor = "black";

  if (userValidated) {
    addnameColor = "green";
  } else {
    addnameColor = "red";
  }
  // useEffect(() => {
  //   if (View_Permission === 1) {
  //     // responseData();
  //     getUsersList
  //   }
  //   return () => {
  //     console.log("resp in return");
  //   };
  //   // eslint-disable-next-line
  // }, [View_Permission]);
  useEffect(() => {
    getRolesSearchList();
    getRolesList();
  }, []);

  const colors = [
    "#CD853F",
    "#DB7093",
    "#778899",
    "#FF00FF",
    "#483D8B",
    "#FF0000",
    "#696969",
    "#DC143C",
    "#556B2F",
  ];
  const [rolesList, setRolesList] = useState(null);
  const [getColor, setColor] = useState("#CD853F");



  const [isEditing, setIsEditing] = useState(false);



  // async function getRolesList() {
  //     dispatch(sidebarReducer.apiLoad(true));
  //     try {
  //         const response = await axios.get("rolepermission/usersRolePermissionBycompanyId/" + JSON.parse(sessionStorage.getItem("userdata")).te_companyid);
  //         if (response.status === 200) {
  //             dispatch(sidebarReducer.apiLoad(false));
  //             setRolesList(response.data.result[0].response);
  //         } else if (response.status !== 200) {
  //             dispatch(sidebarReducer.stringUpdate("AppDown"));
  //         }
  //     } catch (err) {
  //         dispatch(sidebarReducer.stringUpdate("AppDown"));
  //     }
  // }
  // async function getRolesList() {
  //     dispatch(sidebarReducer.apiLoad(true));
  //     try {
  //         const response = await axios.get("roles/list" );
  //         if (response.status === 200) {
  //             dispatch(sidebarReducer.apiLoad(false));
  //             console.log("response - roles",response)
  //             setRolesList(response.data.result[0].response);
  //         } else if (response.status !== 200) {
  //             dispatch(sidebarReducer.stringUpdate("AppDown"));
  //         }
  //     } catch (err) {
  //         dispatch(sidebarReducer.stringUpdate("AppDown"));
  //     }
  // }
  const deleteRole = async (roleId) => {
    try {
      const response = await axios.post(`/roles/delete/${roleId}`, null, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        },
      });
      dispatch(sidebarReducer.apiLoad(false));
      if (response.data.status === 200) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        getRolesList();
      } else {
        toast.warn(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      closeDeleteModal();
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  async function getRolesList() {
    setRolesList([])
    dispatch(sidebarReducer.apiLoad(true));
    // setApiLaod(true);
    await axios

      .get("roles/list", {
        headers: {
          'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token")
        }
      })
      // .get("userProfile/getAllUsers")

      .then((response) => {
        // console.log(" response list users", response.data.data)
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          // console.log("getAllUsers2", response.data.data.rows)
          setRolesList(response.data.data.rows);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }


  const onEdit = (te_role_id) => {

    navigate("/role-update?role=" + te_role_id, { state: { isEditing: true } });

  };

  async function getRolesSearchList(searchTerm) {
    setRolesList([]);
    dispatch(sidebarReducer.apiLoad(true));
  
    const params = searchTerm ? { s: searchTerm } : {};
  
    try {
      const response = await axios.get("roles/list", {
        params: params,
        headers: {
          'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
        }
      });
  
      if (response.status === 200) {
        dispatch(sidebarReducer.apiLoad(false));
        // console.log("getAllRoles", response.data.data.rows);
        setRolesList(response.data.data.rows);
      } else {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      }
    } catch (err) {
      dispatch(sidebarReducer.stringUpdate("AppDown"));
      console.error("Error fetching roles:", err);
    }
  }

  const highlightText = (text, highlight) => {
    if (!highlight.trim()) {
      return text;
    }
    const regex = new RegExp(`(${highlight})`, 'gi');
    return text.replace(regex, '<span class="highlighted-text">$1</span>');
  };

  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  
  const handleSearchSubmit = (event) => {
    event.preventDefault();
    getRolesSearchList(searchTerm);
  };
  return (
    <div className="list-roles-new">
      <ToastContainer closeButton={false} />
      {
        // console.log("entered user")
      }
      {/* {View_Permission === 1 ? ( */}
      <div className="container-fluid">
        <div className="container">
          <div className="row">
            <SearchBarComponent
              className="search-bar-div"
              value={searchTerm}
              onChange={handleSearchChange}
              onSubmit={handleSearchSubmit}
            />
          </div>
        </div>
        <div className="container">
          {/* Toggle swich */}
          <div className="roles-table-container">
            <div className="title-area">
              <h5>Types Of Roles</h5>
              <button className="add-screen-button" type="button" onClick={() => navigate('/role-creation', { state: { isEditing: false } })}>

                <UsersSVG style={{ width: "40px", height: "auto", cursor: "pointer" }} />

                <p >Create New Role</p>

              </button>
            </div>
            <hr></hr>
            <div >

              <div className="roles-list-wrapper">
                <div className="roles-list">
                  {rolesList &&
                    Array.isArray(rolesList) &&
                    rolesList.map((item) => (
                      <div
                        className="list-roles-card"
                        key={item.te_role_id}
                      >
                        <div className="centered-div">
                          <div>
                            <UsersSVG style={{ width: "40px", height: "auto", margin: "0px 10px", cursor: "default" }} />
                          </div>
                          <div className="role-name" dangerouslySetInnerHTML={{
                            __html: highlightText(item.te_role_name, searchTerm)
                          }} />
                        </div>
                        <div className="action-buttons">
                          <EditSVG onClick={() => onEdit(item.te_role_id)} style={{ width: "20px", height: "auto", margin: "0px 5px", cursor: "pointer" }} />
                          <DeleteSVG onClick={() => openDeleteModal(item.te_role_id, item.te_role_name)} style={{ width: "20px", height: "auto", margin: "0px 5px", cursor: "pointer" }} />
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <Modal show={showDeleteModal} onHide={closeDeleteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete the {selectedRoleName} role?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeDeleteModal}>
            Cancel
          </Button>
          <Button style={{ background: "#703BF7 ", border: "#703BF7 " }} onClick={() => deleteRole(selectedRoleId)}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
}

export default ListRoles;